export default __webpack_public_path__ + "static/media/skygit.286923ce.svg";